import { createPinia } from 'pinia'

export const piniaInstance = createPinia()
